import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { enUS, zhCN } from '@/i18n/bundleLocales'

const STORAGE_KEY = 'minego_locale'

export const defaultLng = 'en-US'
export const supportedLngs = ['en-US'] as const

void i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    'en-US': { translation: enUS },
  },
  lng: localStorage.getItem(STORAGE_KEY) ?? defaultLng,
  fallbackLng: defaultLng,
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEY, lng)
  document.documentElement.lang = lng
})

document.documentElement.lang = i18n.language

export default i18n
